import { render, staticRenderFns } from "./default-layout.vue?vue&type=template&id=49b6860b&scoped=true&"
import script from "./default-layout.vue?vue&type=script&lang=ts&"
export * from "./default-layout.vue?vue&type=script&lang=ts&"
import style0 from "./default-layout.vue?vue&type=style&index=0&id=49b6860b&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49b6860b",
  null
  
)

export default component.exports